const styles = (theme) => ({
  downloadLink: {
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    cursor: 'pointer'
  }
});

export default styles;